<template>         
    <div v-if="dataimpresion" id="printme" style="text-align: center; font-size: 10px;">
        <!-- style="width: 460px; min-height: 900px;" -->
         <!-- font-family: Roboto Mono; margin-top: -15px; -->
        <div class="ticket">
            <!-- Datos del emisor -->
            <div class="text-center" style="text-align: center; font-size: 14px;">
                <b-row>
                    <b-col>
                        <template v-if="checked">
                             <!-- :width="ancho+'px'"  -->
                            <img :src="urlimagen" :height="alto+'px'" :width="ancho+'px'" style="margin-left:auto; margin-right:auto;"/>
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template v-if="nombreComercial">
                            <b>{{ nombreComercial }}</b> 
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template>
                            RUC: <b>{{ this.$store.getters.userData.cuenta.idEmisor }}</b> 
                        </template>
                    </b-col>
                </b-row>
                
                <b-row>
                    <b-col>
                        <template v-if="direccion">
                            {{ direccion }}
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template v-if="telefono">
                          Telf: <b>{{ telefono }}</b>
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template v-if="correo">
                            {{ correo }}
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <template v-if="paginaWeb">
                            {{ paginaWeb }}
                        </template>
                    </b-col>
                </b-row>
            </div>
            <div class="text-center" style="text-align: center; font-size: 17px;">
                <template v-if="dataimpresion.codigoComprobante=='03'">
                    <span class="text-center"><b>BOLETA DE VENTA ELECTRÓNICA </b></span>
                </template>
                <template v-if="dataimpresion.codigoComprobante=='01'">
                    <span class="text-center"><b>FACTURA ELECTRÓNICA </b></span>
                </template>
                <template v-if="dataimpresion.proforma && dataimpresion.proforma.adicional.codigoComprobante=='08'">
                    <span class="text-center"><b>PROFORMA</b></span>
                </template>
                <template v-if="dataimpresion.notaVenta && dataimpresion.notaVenta.adicional && dataimpresion.notaVenta.adicional.codigoComprobante =='12'">
                    <span class="text-center"><b>NOTA DE VENTA </b></span>
                </template>
            </div>
            <div class="text-center" style="text-align: center; font-size: 14px;">
                <template v-if="dataimpresion.serie && dataimpresion.numero">
                    <b>{{ dataimpresion.serie }}-{{ dataimpresion.numero }}</b>
                </template>
            </div>
            <!-- Datos del receptor -->
            
            <div class="text-left" style="font-size: 14px;">
                    <template>
                        <div v-if="dataimpresion.idReceptor" style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                            <b>Documento:</b> {{dataimpresion.idReceptor}}
                        </div>
        <!-- proforma -->   <div v-if="dataimpresion && dataimpresion.proforma" style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                                <b>Documento:</b>{{dataimpresion.proforma.receptor.nro}}
                            </div>
                            <div v-if="dataimpresion && dataimpresion.notaVenta" style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                                <b>Documento:</b>{{dataimpresion.notaVenta.receptor.nro}}
                            </div>
                        <div style="display: inline-block; float: rigth; width: 50%; font-size: 14px;">
                            <div v-if="dataimpresion && dataimpresion.adicional && dataimpresion.adicional.username">
                                <b>Usuario:</b> {{ this.dataimpresion.adicional.username }}
                            </div>                          
                            <div v-if="dataimpresion && dataimpresion.notaVenta && dataimpresion.notaVenta.adicional.username">
                                 <b>Usuario:</b> {{ this.dataimpresion.notaVenta.adicional.username}}
                            </div>
                        </div>
                    </template>
                        <div v-if="dataimpresion && dataimpresion.razonSocial">
                            <b>Razon Social:</b> {{ dataimpresion.razonSocial }}
                        </div>
                            <div v-if="dataimpresion && dataimpresion.proforma && dataimpresion.proforma.receptor.razonSocial">
                                <b>Razon Social:</b> {{dataimpresion.proforma.receptor.razonSocial}}
                            </div>
                            <div v-if="dataimpresion && dataimpresion.notaVenta && dataimpresion.notaVenta.receptor.razonSocial">
                                <b>Razon Social:</b> {{dataimpresion.notaVenta.receptor.razonSocial}}
                            </div>
                    <div v-if="dataimpresion && dataimpresion.direccion">
                        <b>Direccion:</b> {{ dataimpresion.direccion }}                      
                    </div>
                        <div v-if="dataimpresion && dataimpresion.proforma && dataimpresion.proforma.receptor.direccionFiscal">
                            <b>Direccion:</b> {{ dataimpresion.proforma.receptor.direccionFiscal }}                      
                        </div>
                        <div v-if="dataimpresion && dataimpresion.notaVenta && dataimpresion.notaVenta.receptor.razonSocial">
                                <b>Dirección:</b> {{dataimpresion.notaVenta.receptor.direccionFiscal}}
                        </div>
                    <template>
                        <div v-if="dataimpresion.fechaEmision" style="display: inline-block; float: left; width: 60%; font-size: 14px;">
                            <b>Fecha:</b> {{ dataimpresion.fechaEmision | moment('D/M/Y') }} - <b>Hora:</b> {{ dataimpresion.fechaEmision | moment('hh:mm:ss A') }}
                        </div>
                            <div v-if="dataimpresion && dataimpresion.created_at" style="display: inline-block; float: left; width: 60%; font-size: 14px;">
                            <b>Fecha:</b> {{ dataimpresion.created_at | moment('D/M/Y') }} -<b> Hora:</b> {{ dataimpresion.created_at | moment('hh:mm:ss A') }} 
                            </div>
                        <div v-if="dataimpresion.tipoMonedaHuman" style="display: inline-block; float: rigth; width: 40%; font-size: 14px;">
                            <b>Moneda:</b> {{ dataimpresion.tipoMonedaHuman }} <br>
                        </div>
                            <div v-if="dataimpresion && dataimpresion.proforma" style="display: inline-block; float: rigth; width: 40%; font-size: 14px;">
                                <b>Moneda:</b> {{ dataimpresion.proforma.moneda }}<br>
                            </div>
                            <div v-if="dataimpresion && dataimpresion.pagos && dataimpresion.pagos.length>0">
                                <b>Forma Pago:</b>
                                <b-list-group>
                                    <div v-for="(item, index) of dataimpresion.pagos" :key="index">
                                        <!-- <li>{{ item.descripcion.substring(0,54) }}...</li> -->
                                    </div>
                                </b-list-group>
                            </div>
                    </template>
            </div><br>
            <b-row>
                <b-col>
                    <div style="display: inline-block; float: left; width: 50%; font-size: 14px;">
                        <b>ART&Iacute;CULO</b>
                    </div>
                    <div class="text-right" style="text-align: right; font-size: 14px; float:rigth; display: inline-block; width: 50%;">
                        <b>SUBTOTAL</b>
                    </div>
                </b-col>
            </b-row>
            <template v-if="dataimpresion.casacambio == '1'">
            <b-row v-for="(item, index) in dataimpresion.items" :key="index">
                <b-col>
                    <div class="text-left" style="text-align: left; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: left; width: 80%;">
                        <span style="margin: 0;">
                            <div v-if="item && item.adicional && item.adicional.numeroPlacaVehiculo">
                                {{item.descripcion}} - Placa: {{ item.adicional.numeroPlacaVehiculo }}
                            </div>
                            <div v-else>
                                {{item.descripcion}}
                            </div>
                        </span>
                        <span style="margin-left: 14px;">{{item.cantidad}} {{item.unidadMedidaHuman}} x {{item.precioVentaUnitario.toFixed(4)}}</span>
                    </div>
                    <div class="text-right" style="text-align: right; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: right; width: 20%;">
                        <span>{{ (item.cantidad*item.precioVentaUnitario).toFixed(4) }}</span>
                    </div>
                </b-col>
            </b-row>
            </template>
            <template v-else>
            <b-row v-for="(item, index) in dataimpresion.items" :key="index">
                <b-col>
                    <div class="text-left" style="text-align: left; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: left; width: 80%;">
                        <span style="margin: 0;">
                            <div v-if="item && item.adicional && item.adicional.numeroPlacaVehiculo">
                                {{item.descripcion}} - Placa: {{ item.adicional.numeroPlacaVehiculo }}
                            </div>
                            <div v-else>
                                {{item.descripcion}}
                            </div>
                        </span>
                        <span style="margin-left: 14px;">{{item.cantidad}} {{item.unidadMedidaHuman}} x {{item.precioVentaUnitario.toFixed(2)}}</span>
                    </div>
                    <div class="text-right" style="text-align: right; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: right; width: 20%;">
                        <span>{{ (item.cantidad*item.precioVentaUnitario).toFixed(2) }}</span>
                    </div>
                </b-col>
            </b-row>
            </template>
            <template v-if="dataimpresion.proforma">
                 <b-row v-for="(item, index) in dataimpresion.proforma.items" :key="index">
                <b-col>
                    <div class="text-left" style="text-align: left; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: left; width: 80%;">
                        <span style="margin: 0;">
                            <div>
                                {{item.descripcion}}
                            </div>
                        </span>
                        <span style="margin-left: 14px;">{{item.cantidad}} {{item.unidadMedidaHuman}} x {{item.precioVentaUnitario.toFixed(2)}}</span>
                    </div>
                    <div class="text-right" style="text-align: right; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: right; width: 20%;">
                        <span>{{ (item.cantidad*item.precioVentaUnitario).toFixed(2) }}</span>
                    </div>
                </b-col>
            </b-row><br>
            </template>
            <template v-if="dataimpresion.notaVenta">
                 <b-row v-for="(item, index) in dataimpresion.notaVenta.items" :key="index">
                <b-col>
                    <div class="text-left" style="text-align: left; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: left; width: 80%;">
                        <span style="margin: 0;">
                            <div>
                                {{item.descripcion}}
                            </div>
                        </span>
                        <span style="margin-left: 14px;">{{item.cantidad}} {{item.unidadMedidaHuman}} x {{item.precioVentaUnitario.toFixed(2)}}</span>
                    </div>
                    <div class="text-right" style="text-align: right; font-size: 14px; margin: 0px; padding: 0px; display: inline-block; float: right; width: 20%;">
                        <span>{{ (item.cantidad*item.precioVentaUnitario).toFixed(2) }}</span>
                    </div>
                </b-col>
            </b-row><br>
            </template>
            <br>
            <div>
                <div class="text-left" style="text-align: left; display: inline-block; width: 60%; font-size: 14px;">
                    <b>Op. Gravada</b><br>
                    <b>I.G.V.</b><br>
                    <div v-if="dataimpresion && dataimpresion.sumatoriaOtrosCargos">
                        <b>Otros Cargos</b>
                    </div>
                    <b>Importe Total</b><br>
                    <div v-if="dataimpresion && dataimpresion.pagos && dataimpresion.pagos.length>0">
                        <b-list-group>
                            <div v-for="(item, index) of dataimpresion.pagos" :key="index">
                                <!-- <b>{{ item.descripcion.substring(0,37) }}...</b> -->
                            </div>
                        </b-list-group>
                    </div>
                    <div v-else-if="dataimpresion && dataimpresion.adicional && dataimpresion.adicional.nombreFormaPago !=''">
                         <!-- <b>{{ dataimpresion.adicional.nombreFormaPago.substring(0,37) }}...</b> -->
                    </div>
                    <div v-else-if="dataimpresion && dataimpresion.notaVenta && dataimpresion.notaVenta.adicional.nombreFormaPago !=''">
                         <!-- <b>{{ dataimpresion.notaVenta.adicional.nombreFormaPago.substring(0,37) }}...</b> -->
                    </div>
                    <!-- <div v-if="dataimpresion && dataimpresion.notaVenta && dataimpresion.notaVenta.adicional.nombreFormaPago !=''">
                         <b>{{ dataimpresion.notaVenta.adicional.nombreFormaPago.substring(0,37) }}...</b>
                    </div> -->
                    <!-- <div v-if="dataimpresion && dataimpresion.pagos && dataimpresion.pagos">
                        <b>Total Importe Pagado</b>
                    </div> -->
                    <!-- <div v-if="dataimpresion && dataimpresion.pagos && dataimpresion.pagos.length>0">
                    <b>Vuelto:</b>                        
                    </div> -->
                    <div>
                    <!-- <b>Vuelto:</b>                         -->
                    </div>
                </div>
                <div class="text-right" style="text-align: right;  display: inline-block; width: 5%; font-size: 14px;">
                    {{ simbolo }}<br>
                    {{ simbolo }}<br>
                    {{ simbolo }}<br>
                    <!-- <div v-if="dataimpresion.pagoCon" >
                    {{ simbolo }}<br>
                    </div> -->
                    
                    <div v-if="dataimpresion && dataimpresion.sumatoriaOtrosCargos">
                        {{ simbolo }}
                    </div>
                    <div v-if="dataimpresion && dataimpresion.pagos && dataimpresion.pagos.length>0">
                        <b-list-group>
                            <div v-for="(item, index) of dataimpresion.pagos" :key="index">
                                {{ simbolo }}
                            </div>
                        </b-list-group>
                    </div>
                    <div v-if="dataimpresion && dataimpresion.pagos && dataimpresion.pagos.length>0">
                        {{ simbolo }}
                    </div>
                    <div v-if="dataimpresion && dataimpresion.pagoCon">
                        {{ simbolo }}<br>
                        {{ simbolo }}<br>
                    </div>
                     <!-- <div v-if="dataimpresion && dataimpresion.pagos && dataimpresion.pagos">
                        {{ simbolo }}<br>
                    </div> -->
                    
                   
                </div>
                <div v-if="dataimpresion" style="text-align: right; display: inline-block; width: 30%; font-size: 14px;">
                    <div class="text-right" v-if="dataimpresion.totalVentaGravada">
                        {{ dataimpresion.totalVentaGravada.toFixed(2)}}
                    </div>
                    <div class="text-right" v-if="dataimpresion.totalVentaGravada == 0">
                       0.00
                    </div>
        <!--proforma--> <div class="text-right" v-if="dataimpresion.proforma">
                            {{ dataimpresion.proforma.totales.totalVentaGravada.toFixed(2)}}
                        </div>
        <!--NV--> <div class="text-right" v-if="dataimpresion.notaVenta">
                            {{ dataimpresion.notaVenta.totales.totalVentaGravada.toFixed(2)}}
                        </div>
                    <div class="text-right" v-if="dataimpresion.sumatoriaIgv">
                        {{ dataimpresion.sumatoriaIgv.toFixed(2)}}
                    </div>
                    <div class="text-right" v-if="dataimpresion.sumatoriaIgv == 0">
                        0.00
                    </div>
        <!--proforma--> <div class="text-right" v-if="dataimpresion.proforma">
                            {{ dataimpresion.proforma.totales.sumatoriaIgv.toFixed(2)}}
                        </div>
        <!--NV--> <div class="text-right" v-if="dataimpresion.notaVenta">
                            {{ dataimpresion.notaVenta.totales.sumatoriaIgv.toFixed(2)}}
                        </div>
                    <div class="text-right" v-if="dataimpresion.sumatoriaOtrosCargos">
                        {{ dataimpresion.sumatoriaOtrosCargos.toFixed(2)}}
                    </div>
        <!-- proforma <div class="text-right" v-if="dataimpresion.proforma.totales.sumatoriaOtrosCargos">
                            {{ dataimpresion.proforma.totales.sumatoriaOtrosCargos.toFixed(2)}}
                        </div> -->
                    <div v-if="dataimpresion.importeTotal" class="text-right">  
                        {{ dataimpresion.importeTotal.toFixed(2)}}
                    </div>
        <!--proforma--> <div v-if="dataimpresion.proforma" class="text-right">   
                            {{ dataimpresion.proforma.totales.importeTotal.toFixed(2)}}
                        </div>
        <!--proforma--> <div v-if="dataimpresion.notaVenta" class="text-right">   
                            {{ dataimpresion.notaVenta.totales.importeTotal.toFixed(2)}}
                        </div>
                    <div class="text-right" v-if="dataimpresion && dataimpresion.pagos && dataimpresion.pagos.length>0">
                        <b-list-group>
                            <div v-for="(item, index) of dataimpresion.pagos" :key="index">
                                {{ parseFloat(item.monto).toFixed(2) }}
                            </div>
                        </b-list-group>
                    </div>
                    <!-- <div class="text-right" v-if="dataimpresion && dataimpresion.pago && dataimpresion.pago">
                        {{ dataimpresion.pago.toFixed(2)}}
                    </div> -->
                    <div v-if="dataimpresion.pagoCon">
                        {{dataimpresion.pagoCon.toFixed(2)}}
                    </div>
                    <div class="text-right" v-if="dataimpresion.vuelto">
                        <!-- {{ dataimpresion.vuelto.toFixed(2) }} -->
                    </div>
                    <div class="text-right" v-else-if="dataimpresion && dataimpresion.pago">
                        0.00
                    </div>
                    <div class="text-right" v-else-if="dataimpresion && dataimpresion.pagos">
                        0.00
                    </div>
                    <div class="text-right" v-else-if="dataimpresion && dataimpresion.pagoCon">
                        0.00
                    </div>
                </div>
            </div>  
            <b-row>
                <b-col>
                    <div class="mt-4" style="font-size: 14px;">
                        <span class="text-left">Son: {{ dataimpresion.importeLetras }} {{ dataimpresion.tipoMonedaHuman }}</span>   
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <div style="font-size: 10px;" v-if="dataimpresion && dataimpresion.adicionales && dataimpresion.adicionales.length>0">
                    <b-col xl="12">
                        Datos Adicionales
                    </b-col>
                    <b-col>
                        <ul>
                            <li v-for="(item, index) in dataimpresion.adicionales" :key="index">{{ item.key }} : {{ item.value }}</li>
                        </ul>
                    </b-col>
                </div>
            </b-row>
            <b-row>
                
            </b-row>
            <b-row v-if="!dataimpresion.proforma">
                <b-col v-if="!dataimpresion.notaVenta">
                    <template v-if="dataimpresion.digestValue!=''">
                        <div style="text-align: center; padding: 0px; margin: 0px;">
                             <template>
                                <vue-qr logoSrc="images/logofo.png" :text="makeHash()" :logoScale=0.2 :dotScale=0.9 :size="130"></vue-qr>
                            </template>
                            <div class="text-center" style="font-size: 14px;">
                                Autorizacion Tarjeta: {{dataimpresion.OperacionCard}}
                            </div>
                            <div class="text-center" style="font-size: 14px;">
                                Hash: {{ dataimpresion.digestValue }}
                            </div>                        
                        </div>
                    </template>
                </b-col>
            </b-row>
            <b-row v-if="!dataimpresion.proforma">
                <b-col v-if="!dataimpresion.notaVenta">
                    <div class="text-center" style="text-align: center; font-size: 14px;padding-right: 5px;padding-left: 5px; margin-bottom: 1px;">Autorizado mediante resolución 034-030-0000103/SUNAT,<br> representación impresa del comprobante en:
                        <br> https://facturaonline.pe
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <template v-if="textoPersonalizado1 !=''">
                        <div class="text-center" style="text-align: center; font-size: 14px;">
                            {{ textoPersonalizado1 }} 
                        </div>
                    </template>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <template v-if="textoPersonalizado2 !=''">
                       <div class="text-center" style="text-align: center; font-size: 14px;">
                            {{ textoPersonalizado2 }}
                        </div>
                    </template>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import VueQr from 'vue-qr'
    export default {
        name: 'PlantillaImpresionTemporal',
        props: ['impresion', 'printweb'],
        components: {
            VueQr
        },
        data:() => {
            return {
                checked: true,
                alto: '',
                ancho: '',
                urlimagen: '',
                tipodoc: 1,
                digestvalue: '',
                dataimpresion: {},
                simbolo: '',
                hash: '',
                telefono: '',
                nombreComercial: '',
                direccion: '',
                paginaWeb: '',
                correo: '',
                textoPersonalizado1: '',
                textoPersonalizado2: ''
            }
        },
        mounted() {
            this.setData(),
            this.getDataImpresion()
        },
        watch: {
            printweb: function () {
                if(this.printweb){
                    var printContents = document.getElementById("printme").innerHTML
                    var myWindow = window.open("", "MsgWindow", "width=400,height=800")
                    myWindow.document.body.style.fontSize='10px'
                    myWindow.document.body.style.textAlign='center'
                    myWindow.document.write(printContents)
                    myWindow.print(printContents)
                    myWindow.close()
                }
            }
        },
        methods: {
            getDataImpresion: function () {
                axios
                .post(process.env.VUE_APP_API_URL + 'movil/informacioncliente/mostrar', {
                    token: this.$store.getters.userToken
                })
                .then(response => (
                    this.dataLogo(response.data.response)
                ))
                .catch(error => (
                    this.checked = true,
                    this.alto = '100',
                    this.ancho = '150'
                ))
            },
            dataLogo: function (data) {
                this.telefono = data.telefono
                this.nombreComercial = data.nombreComercial
                this.direccion =  data.direccion
                this.paginaWeb = data.paginaWeb
                this.correo = data.correo
                this.textoPersonalizado1 = data.textoPersonalizado1
                this.textoPersonalizado2 = data.textoPersonalizado2
                if(data.impLogo == 1){
                    this.checked = true
                    this.alto = data.altoLogo
                    this.ancho = data.anchoLogo
                }else if(data.impLogo == 0){
                    this.checked = false
                    this.alto = '100'
                    this.ancho = '150'
                }
            },
            makeHash: function() {
                if(Object.keys(this.dataimpresion).length != 0){
                    let tiporec = ''
                    this.dataimpresion.tiporeceptor == '6'? tiporec = '06': tiporec = '01'
                    this.hash = this.dataimpresion.idEmisor+'|'+
                                this.dataimpresion.codigoComprobante+'|'+
                                this.dataimpresion.serie+'|'+
                                this.dataimpresion.numero+'|'+                              
                                String(this.dataimpresion.sumatoriaIgv) +'|'+
                                String(this.dataimpresion.importeTotal) +'|'+                                                       
                                this.$moment(this.dataimpresion.fechaEmision).format('DD/MM/YYYY')+'|'+
                                tiporec+'|'+
                                this.dataimpresion.idReceptor
                }
                return this.hash
            },
            setData: function () {
                this.dataimpresion = this.impresion,
                this.urlimagen = this.$store.getters.userData.cuenta.uriImagen
                if(this.dataimpresion.proforma){
                    this.tipoMoneda2()
                }else if(this.dataimpresion.codigoComprobante !=''){
                    this.tipoMoneda()
                }
            },
            tipoMoneda: function () {
                if(this.dataimpresion.tipoMoneda == 'PEN'){
                    this.simbolo = 'S/'
                }else if(this.dataimpresion.tipoMoneda == 'USD'){
                    this.simbolo = '$'
                }else if(this.dataimpresion.notaVenta.moneda.codigo == 'PEN'){
                    this.simbolo = 'S/'
                }else if(this.dataimpresion.notaVenta.moneda.codigo == 'USD'){
                    this.simbolo = '$'
                }else{
                    this.simbolo = this.dataimpresion.tipoMoneda
                 }
            },
            tipoMoneda2(){
                if(this.dataimpresion.proforma.moneda = 'PEN'){
                    this.simbolo = 'S/'
                }else if(this.dataimpresion.proforma.moneda = 'USD'){
                    this.simbolo = '$'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ticket{
        border: 1px solid #ccc;
        border-radius: 10px;
        padding: 10px;
    }
    // .medida{
    //     font-size: 12px;
    // }
</style>